<mat-dialog-content>
  <div class="menu">
    <label (click)="active = 'vertical'">
      <span [ngClass]="{ active: active === 'vertical' }" title="pionowe"
        translate>clgmeiryt000009me44ggfzde</span
        >
        <div [ngClass]="{ active: active === 'vertical' }" class="vertical"></div>
      </label>
      <label (click)="active = 'horizontal'">
        <span [ngClass]="{ active: active === 'horizontal' }" title="poziome"
          translate>clgmeivqx000109me3tzj92np</span
          >
          <div
            [ngClass]="{ active: active === 'horizontal' }"
            class="horizontal"
          ></div>
        </label>
      </div>
      <div [formGroup]="model" class="content">
        @if (active === 'horizontal') {
          <app-watermark-for-image-manager
            [ratio]="3 / 2"
            formControlName="horizontal"
          ></app-watermark-for-image-manager>
        }
        @if (active === 'vertical') {
          <app-watermark-for-image-manager
            [ratio]="2 / 3"
            formControlName="vertical"
          ></app-watermark-for-image-manager>
        }
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <span #saveButton (click)="validate(saveButton) && saved.next(model.value)">
        <lib-button forceContext="publicSessionEditor" translate>save</lib-button>
      </span>
      <lib-button bare mat-dialog-close forceContext="publicSessionEditor" translate>cancel</lib-button>
    </mat-dialog-actions>
